import React from 'react';
import GridImage from './GridImage';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const RenaultProjectGrid = (props) => {
    let currentProjectIndex = props.projects.findIndex(project => project.path === props.path);
    let gridImages = props.projects[currentProjectIndex].gridImages;
    return (
        <div>
            <div className="project-slide"></div>
            <div className="project-grid renault-project container">
                <div className="flex">
                    {/*<img className="grid-img-1" src="/assets/img/homes/renault/02.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-1', asset: gridImages[1], sizes: ''}}/>
                    <svg className="grid-svg-1" x="0px" y="0px" width="6" height="575" viewBox="0 0 6 575">
                        <text className="yrsa-li" x="0" y="10" fill="#545454">
                            <tspan x="0" style={{fontSize: '9px'}}>r</tspan>
                            <tspan x="0" dy="94" style={{fontSize: '10px'}}>e</tspan>
                            <tspan x="0" dy="94" style={{fontSize: '11px'}}>n</tspan>
                            <tspan x="0" dy="94" style={{fontSize: '12px'}}>a</tspan>
                            <tspan x="0" dy="94" style={{fontSize: '13px'}}>u</tspan>
                            <tspan x="0" dy="94" style={{fontSize: '14px'}}>l</tspan>
                            <tspan x="0" dy="94" style={{fontSize: '15px'}}>t</tspan>
                        </text>
                    </svg>
                </div>
                <div className="flex flex-container-1">
                    <svg className="grid-svg-2" x="0px" y="0px" width="6" height="590" viewBox="0 0 6 590">
                        <text className="renault-text barlow-me-it" x="0" y="7" fill="#af2100">
                            <tspan x="0">R</tspan>
                            <tspan x="0" dy="96">R</tspan>
                            <tspan x="0" dy="96">R</tspan>
                            <tspan x="0" dy="96">R</tspan>
                            <tspan x="0" dy="96">R</tspan>
                            <tspan x="0" dy="96">R</tspan>
                            {/*<tspan x="0" dy="94">R</tspan>*/}
                        </text>
                    </svg>
                    <svg className="grid-svg-3" x="0px" y="0px" width="4" height="590" viewBox="0 0 4 590">
                        <text className="renault-text barlow-it" x="0" y="6" fill="#af2100">
                            <tspan x="0">r</tspan>
                            <tspan x="0" dy="94">r</tspan>
                            <tspan x="0" dy="94">r</tspan>
                            <tspan x="0" dy="94">r</tspan>
                            <tspan x="0" dy="94">r</tspan>
                            <tspan x="0" dy="94">r</tspan>
                            <tspan x="0" dy="94">r</tspan>
                        </text>
                    </svg>
                    {/*<img className="grid-img-2" src="/assets/img/homes/renault/03.jpg" alt=""/>*/}
                    <GridImage params={{className: 'grid-img-2', asset: gridImages[2], sizes: ''}}/>
                </div>
                <div className="flex credits-container">
                    <div className="credits desktop">
                        <span className="credits-title red">Credits</span>
                        <ul className="no-style">
                            <li><span className="red barlow-me">Client</span> Renault</li>
                            <li><span className="red barlow-me">Agency</span> Publicis Conseil</li>
                            <li><span className="red barlow-me">Production</span> Wandaprint</li>
                            <li><span className="red barlow-me">3D Artist</span> Denis Seounes</li>
                            <li><span className="red barlow-me">Photographer</span> Ronan Merot</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

// export default RenaultProjectGrid;
const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(RenaultProjectGrid));


// WEBPACK FOOTER //
// ./src/components/RenaultProjectGrid.js